module.exports = __webpack_public_path__ + "static/NepalToday-screenshot-49fdb166b9a65674ce1f4c9dbbee1d70.png";